import { render, staticRenderFns } from "./greeting.vue?vue&type=template&id=4136e441&"
import script from "./greeting.vue?vue&type=script&lang=js&"
export * from "./greeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports